"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollDetector = void 0;
var constants_1 = require("../data/constants");
var constantsClasses_1 = require("../data/constantsClasses");
function scrollDetector() {
    var header = document.querySelector("[".concat(constants_1.DATA_HEADER, "]"));
    var lastScrollY = window.scrollY;
    window.addEventListener('scroll', function () {
        var currentScrollY = window.scrollY;
        if (currentScrollY > lastScrollY) {
            header.classList.add(constantsClasses_1.CLASS_SCROLL);
        }
        else {
            header.classList.remove(constantsClasses_1.CLASS_SCROLL);
        }
        lastScrollY = currentScrollY;
    });
}
exports.scrollDetector = scrollDetector;
